import React, { forwardRef } from 'react';
import getI18N from '../../lib/i18n';
import { OnChangeEvent } from '../Input/Input';
import styles from './FileSelect.module.scss';

interface FileSelectProps {
    value?: string;
    onChange?: (event: OnChangeEvent) => void;
    label?: string;
}

const defaultProps: FileSelectProps = {
    value: '',
    onChange: () => null,
    label: '',
};

const i18n = getI18N();

const FileSelect = forwardRef<HTMLInputElement, FileSelectProps>(({ value, ...props }, ref) => {
    const id = React.useId();

    return (
        <div className={styles['file-select-container']}>
            <span className={styles['input-header']}>{props.label}</span>
            <input
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                type="file"
                accept="image/*"
                id={id}
                className={styles['file-input']}
                onClick={(event) => {
                    const target = event.target as HTMLInputElement;
                    target.value = '';
                }}
                ref={ref}
            />
            <label htmlFor={id} className={styles['input-label']}>
                {i18n('Загрузить', { context: 'загрузка на сайт' })}
            </label>
        </div>
    );
});

FileSelect.defaultProps = defaultProps;

export default FileSelect;
